import React, { useState, useEffect } from "react";

import TrackOrderIcon from "../assets/images/profile/map.svg";
// import OrderReturnIcon from "../assets/images/profile/order-return.svg";
// import CartImg from "../assets/images/cart/cart-img.png";
import BackImg from "../assets/images/cart/back-icon.svg";
import InvoiceImg from "../assets/images/profile/invoice.svg";
import Skeleton from "react-loading-skeleton";

import { Link } from "react-router-dom";
import ShowMoreOrdersIcon from "../assets/images/show-more-products-icon.svg";
import {
  formatPrice,
  formatDate,
  // addressStringCreate,
  // formatPhoneNumber,
} from "../helpers/helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  getReturnOrders,
  clearOrderReturnMessages,
} from "../features/order_return/orderReturnActions";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function ReturnOrdersComp() {
  const [returnOrderDetail, setReturnOrderDetail] = useState("");

  const [isActive, setIsActive] = useState(false);

  const handleToggle = (order) => {
    setReturnOrderDetail(order);
    setIsActive((prevState) => !prevState);
  };

  // State to manage pagination
  const [page, setPage] = useState(1);

  // State to store all fetched orders
  const [allOrders, setAllOrders] = useState([]);

  // visible show more
  const [isVisibleShowMore, setIsVisibleShowMore] = useState(true);

  const dispatch = useDispatch();
  const { loading, errorMessage, returnOrders } = useSelector(
    (state) => state.order_return
  );

  useEffect(() => {
    setAllOrders([]);
    let data = { page: 1, limit: 3 };
    dispatch(getReturnOrders(data));
  }, [dispatch]);

  useEffect(() => {
    if (returnOrders?.data) {
      setAllOrders((prev) => [...prev, ...returnOrders.data]);
      setIsVisibleShowMore(returnOrders.data.length >= 3);
    } else {
      setIsVisibleShowMore(false);
    }
  }, [returnOrders]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 5000, hideProgressBar: true, className: "toast-error" });
      dispatch(clearOrderReturnMessages()); // Reset the messages after showing the toast
    }
  }, [errorMessage, dispatch]);

  const loadMoreOrders = () => {
    const nextPage = page + 1;
    let data = { page: nextPage, limit: 3 };
    dispatch(getReturnOrders(data));
    setPage(nextPage); // Update the page number
  };

  const sumOfqty = (orderItems) => {
    return orderItems.reduce((sum, item) => sum + item.qty, 0);
  };

  const displayOrderStatus = (item) => {
    if (item.status_id === 1) {
      return (
        <Link
          style={{ padding: "10px clamp(14px, 0.24vw, 2px)" }}
          to=""
          className="cutsom-bttn delivered-bttn"
        >
          Initiated
        </Link>
      );
    } else if (item.status_id === 2) {
      return (
        <Link
          style={{ padding: "10px clamp(14px, 0.24vw, 2px)" }}
          to=""
          className="cutsom-bttn order-return-bttn"
        >
          Picked Up
        </Link>
      );
    } else if (item.status_id === 3) {
      return (
        <Link
          style={{ padding: "10px clamp(14px, 0.24vw, 2px)" }}
          to=""
          className="cutsom-bttn delivered-bttn"
        >
          Received
        </Link>
      );
    } else {
      // Dynamically add the background color class
      return (
        <Link
          style={{ padding: "10px clamp(14px, 0.24vw, 2px)" }}
          to=""
          className={`cutsom-bttn bg-${item.status_bg_color}`}
        >
          {item.status_title}
        </Link>
      );
    }
  };

  const displayTrackOrderDetails = (item) => {
    if (item.awb_url === "") {
      return null;
    } else {
      return (
        <Link
          to={item.awb_url}
          target="_blank"
          className="cutsom-bttn track-order-bttn"
        >
          <img src={TrackOrderIcon} alt="" /> Track Order
        </Link>
      );
    }
  };

  return (
    <>
      <div className={`${isActive ? "my-order-info isHide" : "my-order-info"}`}>
        <div className="tab-content-header">
          <h3>Return Orders</h3>
        </div>

        {loading && allOrders.length === 0 ? ( // Check if loading is true
          <div className="skeleton-loader">
            {Array(3)
              .fill()
              .map(
                (
                  _,
                  index // Adjust the number of skeletons as needed
                ) => (
                  <div className="order-info-box" key={`skeleton-rk-${index}`}>
                    <div className="order-info-box-header">
                      <Skeleton height={20} width="80%" />
                      <Skeleton height={15} width="50%" />
                    </div>
                    <div className="order-info-box-body">
                      {Array(2)
                        .fill()
                        .map(
                          (
                            _,
                            itemIndex // Skeleton for order items
                          ) => (
                            <div
                              className="order-info-box-item"
                              key={`skeleton-item-${itemIndex}`}
                            >
                              <div className="cart-box">
                                <div className="cart-box-img">
                                  <Skeleton
                                    height={95}
                                    width={95}
                                    style={{ marginLeft: 5, borderRadius: 10 }}
                                  />
                                </div>
                                <div className="qty-wrapper">
                                  <span>
                                    <Skeleton height={15} width="100%" />
                                  </span>
                                  <h2>
                                    <Skeleton height={10} width="90%" />
                                  </h2>
                                  <span>
                                    <Skeleton height={10} width="85%" />
                                  </span>
                                </div>
                              </div>
                              <div className="qty-wrapper">
                                <Skeleton height={15} width="40%" />
                                <Skeleton height={15} width="40%" />
                              </div>
                              <div className="bttn-group">
                                <Skeleton height={30} width="80%" />
                              </div>
                            </div>
                          )
                        )}
                    </div>
                  </div>
                )
              )}
          </div>
        ) : allOrders?.length > 0 ? (
          <>
            {allOrders.map((order, index) => (
              <div className="order-info-box" key={"r"+order.id+index}>
                <div
                  className="order-info-box-header"
                  onClick={() => handleToggle(order)}
                >
                  <h4>
                    {order.order_number} <span></span> Qty :{" "}
                    {sumOfqty(order.order_items)}
                  </h4>
                  <h5>Order Date : {formatDate(order.created_at)}</h5>
                </div>
                <div className="order-info-box-body">
                  {order.order_items.map((item, item_index) => (
                    <div
                      className="order-info-box-item"
                      key={"item-" + item.id}
                    >
                      <div className="cart-box">
                        <div className="cart-box-img">
                          <Link to={"/products/" + item?.product.slug}>
                            <img
                              src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${item?.product.image}`}
                              alt=""
                            />
                          </Link>
                        </div>
                        <div className="cart-box-content">
                          <span>{item?.product?.category_title}</span>
                          <h2>
                            <Link to={"/products/" + item?.product.slug}>
                              {item?.product?.title}
                            </Link>
                          </h2>
                          <Link to={"/products/" + item?.product.slug}>
                            {item.variation_title}
                          </Link>
                          &nbsp;&nbsp;|&nbsp;&nbsp;
                          <Link
                            to={"/products/" + item?.product.slug}
                            className="price-value"
                          >
                            {order.currency} {formatPrice(item.return_price)}
                          </Link>
                        </div>
                      </div>
                      <div className="qty-wrapper">
                        <p className="mb-0"> Qty : {item.qty}</p>
                        <p className="mb-0">
                          {" "}
                          Total Refund : {order.currency}{" "}
                          {formatPrice(item.total_return_price)}
                        </p>
                      </div>
                      <div className="bttn-group">
                        {displayTrackOrderDetails(item)}
                        {displayOrderStatus(item)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </>
        ) : (
          <p className={loading ? "d-none" : ""}>
            No orders found in the account.
          </p>
        )}

        <div className="d-flex justify-content-center">
          <Link
            to="#"
            onClick={loadMoreOrders}
            className={`cutsom-bttn ${!isVisibleShowMore ? "d-none" : ""}`}
          >
            {loading ? (
              <FontAwesomeIcon
                icon={faSpinner}
                spin
                size="lg"
                className="spinner-icon"
              />
            ) : (
              <>
                Show More Orders <img src={ShowMoreOrdersIcon} alt="" />
              </>
            )}
          </Link>
        </div>
      </div>

      {returnOrderDetail && (
        <div
          className={`${
            isActive ? "order-details-info" : "order-details-info isHide"
          }`}
        >
          <div className="tab-content-header">
            <h3>
              <Link
                to=""
                className="backToList"
                onClick={() => handleToggle(returnOrderDetail)}
              >
                <img src={BackImg} alt="" />
              </Link>{" "}
              Order Details
            </h3>
          </div>
          <div className="order-info-box">
            <div className="order-info-box-header">
              <h4>
                {returnOrderDetail.order_number} <span></span> Qty :{" "}
                {sumOfqty(returnOrderDetail.order_items)}
              </h4>
              <div className="order-info-box-header-right">
                <h5>Order Date : {formatDate(returnOrderDetail.created_at)}</h5>{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${returnOrderDetail.invoice_file}`}
                  download
                  className="cutsom-bttn track-order-bttn"
                >
                  <img src={InvoiceImg} alt="" /> Invoice
                </a>
                
                {/* <Link to="" className="cutsom-bttn track-order-bttn style-2">
                <img src={TrackOrderIcon} alt="" /> Track Order
              </Link> */}
              </div>
            </div>
            <div className="order-info-box-body">
              {returnOrderDetail.order_items.map((item, item_index) => (
                <div className="order-info-box-item" key={"k" + item.id + item_index}>
                  <div className="cart-box">
                    <div className="cart-box-img">
                      <Link to={"/products/" + item?.product.slug}>
                        <img
                          src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${item?.product.image}`}
                          alt=""
                        />
                      </Link>
                    </div>
                    <div className="cart-box-content">
                      <span>{item?.product?.category_title}</span>
                      <h2>
                        <Link to={"/products/" + item?.product.slug}>
                          {item?.product?.title}
                        </Link>
                      </h2>
                      <Link to={"/products/" + item?.product.slug}>
                        {item.variation_title}
                      </Link>
                      &nbsp;&nbsp;|&nbsp;&nbsp;
                      <Link
                        to={"/products/" + item?.product.slug}
                        className="price-value"
                      >
                        {returnOrderDetail.currency} {formatPrice(item.return_price)}
                      </Link>
                
                    </div>
                  </div>
                  <div className="qty-wrapper">
                    <p className="mb-0"> Qty : {item.qty}</p>
                    <p className="mb-0">
                      {" "}
                      Total Refund : {returnOrderDetail.currency}{" "}
                      {formatPrice(item.total_return_price)}
                    </p>
                  </div>
                  <div className="bttn-group">
                    {displayTrackOrderDetails(item)}
                    {displayOrderStatus(item)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default ReturnOrdersComp;
